<div>
  @if (loading) {
    <myp-skeleton-loader type="product-tile" height="250px" number="6" class="grid-container pad-10"></myp-skeleton-loader>
  }

  @if (creator) {
    @if (!loading && wares && wares.data.length) {
      <div>
        <myp-exchange-list
          (itemTapped)="exchangeAssetClicked.next($event)"
          [creator_id]="creator_id"
          [displayedCategory]="{ title: 'myitems', display_name: 'MY ITEMS' }"
          limit="10"
          [wares]="wares"
        ></myp-exchange-list>
      </div>
    }
    @if (wares && wares.data && !wares.data.length) {
      <div class="m-y-50">
        {{ isMe ? ("exchange.havent_created_anything" | translate) : ("sphere.user_not_created_anything" | translate) }}
      </div>
    }
  }
</div>
